/**
 * @license @lucide/lab v0.1.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const horseHead = [
  ["path", { d: "M11.5 12H11", key: "dwhguf" }],
  [
    "path",
    {
      d: "M5 15a4 4 0 0 0 4 4h7.8l.3.3a3 3 0 0 0 4-4.46L12 7c0-3-1-5-1-5S8 3 8 7c-4 1-6 3-6 3",
      key: "571my3"
    }
  ],
  ["path", { d: "M6.14 17.8S4 19 2 22", key: "l04gdj" }]
];

export { horseHead as default };
//# sourceMappingURL=horse-head.js.map
